import { render, staticRenderFns } from "./getintouchnav.vue?vue&type=template&id=6bfe802a&scoped=true&"
import script from "./getintouchnav.vue?vue&type=script&lang=js&"
export * from "./getintouchnav.vue?vue&type=script&lang=js&"
import style0 from "./getintouchnav.vue?vue&type=style&index=0&id=6bfe802a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe802a",
  null
  
)

export default component.exports